

<template>
  <div class="p3">
    <img
      class="p3_img"
      alt="move on"
      src="https://summit-img.geekpark.net/r2020/pc_p3_no_text_4.svg"
    />
    <!-- <img
      class="p3_top_title"
      alt="top title"
      src="https://summit-img.geekpark.net/r2020/pc_p3_top_title_4.svg"
    />-->
    <div
      class="pengge_wrapper"
      href="https://space.bilibili.com/519227473?from=search&seid=13418580983684229411"
      target="_blank"
    >
      <img class="pengge" src="https://summit-img.geekpark.net/r2020/pc_pengge_8.png" />
      <a
        class="live_btn_wrapper"
        href="https://space.bilibili.com/519227473?from=search&seid=13418580983684229411"
        target="_blank"
      >
        <img class="live_btn" src="https://summit-img.geekpark.net/r2020/live_btn_2.svg" />
      </a>
    </div>
    <div class="p3_text_wrapper">
      <div class="title">
        <img alt="联系我们" src="https://summit-img.geekpark.net/r2020/pc_contact_title.svg" />
      </div>
      <div class="join_thing">
        <div class="subtitle">
          <img alt="参会事宜" src="https://summit-img.geekpark.net/r2020/pc_join_title.svg" />
        </div>
        <a
          class="emial_href"
          href="mailto:rebuild.register@geekpark.net"
        >rebuild.register@geekpark.net</a>
      </div>
      <div class="business_thing">
        <div class="subtitle">
          <img alt="招商合作" src="https://summit-img.geekpark.net/r2020/pc_business_title.svg" />
        </div>
        <a class="emial_href" href="mailto:rebuild.bd@geekpark.net">rebuild.bd@geekpark.net</a>
      </div>
      <div class="media_thing">
        <div class="subtitle">
          <img alt="媒体合作" src="https://summit-img.geekpark.net/r2020/pc_media_title.svg" />
        </div>
        <a class="emial_href" href="mailto:rebuild.media@geekpark.net">rebuild.media@geekpark.net</a>
      </div>
      <div class="weixin_assitant">
        <div class="subtitle">
          <img
            alt="小助手微信"
            src="https://summit-img.geekpark.net/r2020/pc_wexin_assitant_title_4.svg"
          />
          <div class="emial_href">GEEKPARKGO</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "P3"
};
</script>

<style scoped lang="less">
.p3 {
  height: 100vh;
  width: auto;
  display: flex;
  align-items: center;
  color: #fff;
  position: relative;
  margin-left: 18vh;

  .p3_img {
    height: 100vh;
    width: auto;
    position: relative;
  }
  .p3_top_title {
    position: absolute;
    top: 8vh;
    left: 0;
    height: 44vh;
    width: auto;
  }
  .pengge_wrapper {
    position: absolute;
    bottom: 7vh;
    left: -18vh;
    height: 86vh;
    width: auto;
    .pengge {
      height: 100%;
      width: auto;
    }
    .live_btn_wrapper {
      position: absolute;
      top: 30vh;
      left: 82vh;
      .live_btn {
        height: 8vh;
        width: auto;
      }
    }
  }

  .p3_text_wrapper {
    position: absolute;
    right: 86vh;
    bottom: 14vh;
  }
  .title {
    margin-bottom: 60px;
    img {
      height: 4vh;
    }
  }
  .join_thing,
  .business_thing,
  .media_thing {
    margin-bottom: 30px;
  }
  .subtitle {
    img {
      height: 2vh;
    }
  }
  .emial_href {
    font-size: 2vh;
    color: #fff;
    text-shadow: -0.5px 0 #555, 0 0.5px #555, 0.5px 0 #555, 0 -0.5px #555;
    text-decoration: none;
  }
}

@media screen and (min-height: 500px) and (max-height: 768px) {
  .p3 {
    .p3_text_wrapper {
      bottom: 12vh;
    }
    .title {
      margin-bottom: 30px;
    }
    .join_thing,
    .business_thing,
    .media_thing {
      margin-bottom: 16px;
    }
  }
}

@media screen and (min-height: 400px) and (max-height: 500px) {
  .p3 {
    .p3_text_wrapper {
      bottom: 8vh;
    }
    .title {
      margin-bottom: 20px;
    }
    .join_thing,
    .business_thing,
    .media_thing {
      margin-bottom: 8px;
    }
  }
}

@media screen and (max-height: 400px) {
  .p3 {
    .p3_text_wrapper {
      bottom: 12vh;
      right: 76vh;
    }
    .title {
      margin-bottom: 6px;
    }
    .join_thing,
    .business_thing,
    .media_thing {
      margin-bottom: 4px;
    }
  }
}
</style>